import axios from 'axios'
import laroute from '~/laroute'

export const state = {
  shipper: {}
}

export const getters = {
  shipper: state => state.shipper
}

export const mutations = {
  SHIPPER (state, data) {
    state.shipper = data
  }
}

export const actions = {
  async getShipper ({ commit }, id) {
    await axios.get(laroute.route('get-shipper', { id }))
      .then((res) => {
        commit('SHIPPER', res.data)
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/extraData.js